import { useCallback, useState } from "react"
import { setToken, setUser } from "../../redux/slices/appStateSlice";
import CustomModal from "../../commons/modals/CustomModal";
import { Field, Form, FormElement } from "@progress/kendo-react-form";
import { Button } from "@progress/kendo-react-buttons";
import { useLoginWithCredentialsMutation } from "../../redux/api/login";
import { useDispatch } from "react-redux";
import { TOKEN, USER } from "../../constants/localStorage";
import { FormInput } from "../../commons/forms/FormInput";
import { required } from "../../commons/forms/Validators";
import { approbationWebAPI } from "../../redux/api/cache";
import LoaderContainer from "../../commons/container/LoaderContainer";
import "./connection.css";

export default function ConnectionPage() {
  const [loginWithCredentials] = useLoginWithCredentialsMutation();
  const dispatch = useDispatch();
  const [error, setError] = useState<string | undefined>(undefined);
  const [isLoading, setIsLoading] = useState<boolean>(false);


  const handleSubmit = useCallback(
    async (dataItem: { [name: string]: any }) => {
      setIsLoading(true);
      await loginWithCredentials({ user: dataItem.user, password: dataItem.password }).unwrap().then((result) => {
        dispatch(approbationWebAPI.util.resetApiState());
        let token = result.headers.get('Authorization');
        if (token && dataItem.user) {
          localStorage.setItem(TOKEN, token);
          localStorage.setItem(USER, dataItem.user);
          dispatch(setToken(token));
          dispatch(setUser(dataItem.user));
        }
        setError(undefined);
      }).catch((result) => {
        let messageErreur = result.status === 401 ? "Les identifiants sont invalides!" : "La connexion a échoué!";
        setError(messageErreur);
        setIsLoading(false);
      });
    },
    [dispatch, loginWithCredentials]
  );

  const userValidator = (e: any) => required(e, 'Utilisateur');
  const passwordValidator = (e: any) => required(e, 'Mot de passe')

  return (<div><CustomModal
    closeIcon={false}
    width={'400px'}
    title="Connexion"
    body={
      isLoading ? (
        <div className="loading-view">
          <LoaderContainer />
        </div>
      ) : (
        <Form
          onSubmit={handleSubmit}
          render={(formRenderProps) => (
            <FormElement>
              {error !== undefined && (
                <blockquote className="custom-blockquote error-sm ">
                  <span>{error}</span>
                </blockquote>
              )}
              <fieldset className={'k-form-fieldset'}>
                <Field
                  id={'user'}
                  name={'user'}
                  label={'Utilisateur'}
                  component={FormInput}
                  validator={userValidator}
                />
                <Field
                  id={'password'}
                  name={'password'}
                  label={'Mot de passe'}
                  type={'password'}
                  component={FormInput}
                  validator={passwordValidator}
                />
                <div className="k-form-buttons">
                  <Button
                    type={'submit'}
                    className="blueButton"
                    disabled={!formRenderProps.allowSubmit}
                  >
                    Se connecter
                  </Button>
                </div>
              </fieldset>
            </FormElement>
          )}
        />
      )
    }
  /></div>);
}

